function Unlike({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4626_389)">
        <mask id="mask0_4626_389" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <path d="M0 24L24 24L24 0L0 0L0 24Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_4626_389)">
          <path d="M15 3L6 3C5.17 3 4.46 3.5 4.16 4.22L1.14 11.27C1.05 11.5 1 11.74 1 12V14C1 15.1 1.9 16 3 16L9.31 16L8.36 20.57L8.33 20.89C8.33 21.3 8.5 21.68 8.77 21.95L9.83 23L16.42 16.41C16.78 16.05 17 15.55 17 15V5C17 3.9 16.1 3 15 3ZM15 15L10.66 19.34L12 14H3V12L6 5L15 5L15 15ZM23 15H19L19 3H23L23 15Z" fill="#5F6F86"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4626_389">
          <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 -1 24 24)"/>
        </clipPath>
      </defs>
    </svg>
  `;
  return baseXml;
}

export default Unlike;
